/** Session cookie name. Value is `<deviceId>.<token>`. */
export const SESSION_COOKIE = 'fdpf_session';
/**
 * Device sessions are long-lived on purpose: a photo frame should be authorised once, forever.
 *
 * This is a *sliding* window, not a deadline — /api/session and the heartbeat re-issue the cookie on
 * every reply, so only a device untouched for a whole year lapses. Kept under the 400-day ceiling that
 * Chrome (104+) clamps cookie lifetimes to; asking for more would silently get truncated.
 */
export const SESSION_MAX_AGE_SECONDS = 365 * 24 * 60 * 60;
/** Invite links are single-use and short-lived. */
export const INVITE_TTL_SECONDS = 24 * 60 * 60;
/** Media derivatives are content-hash addressed, so they can never change under a given URL. */
export const MEDIA_CACHE_CONTROL = 'private, max-age=31536000, immutable';
/**
 * Long edge of the `display` JPEG. 2560 covers every retina iPad/desktop we care about while
 * keeping files around 200-400KB, which is what makes whole-album precaching viable.
 */
export const DISPLAY_LONG_EDGE = 2560;
export const DISPLAY_JPEG_QUALITY = 82;
export const THUMB_LONG_EDGE = 400;
export const THUMB_JPEG_QUALITY = 70;
/** Videos are transcoded to this ceiling by the ingest CLI before upload. */
export const VIDEO_MAX_HEIGHT = 720;
/** Default client-side media cache budget. Old iPads have no reliable quota API, so we self-account. */
export const DEFAULT_CACHE_BUDGET_BYTES = 400 * 1024 * 1024;
/** Default seconds each photo is held during autoplay. */
export const DEFAULT_SLIDE_SECONDS = 8;
export const PHOTO_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.heic', '.heif', '.tif', '.tiff', '.webp'];
export const VIDEO_EXTENSIONS = ['.mp4', '.mov', '.m4v', '.avi', '.mkv', '.3gp'];
/**
 * Anything at or below this goes up in one request; larger objects (4K video originals, mostly) use
 * R2 multipart. The Workers free plan caps a request body at 100 MB, so this leaves headroom.
 */
export const MAX_SINGLE_UPLOAD_BYTES = 80 * 1024 * 1024;
/** R2 requires every part except the last to be at least 5 MB and all parts to be the same size. */
export const MULTIPART_PART_BYTES = 16 * 1024 * 1024;
//# sourceMappingURL=constants.js.map